// import React from 'react';
import List from '../layout/list'
import Accordion from '../parts/accordion'
import InputAndSelect from '../parts/form/InputAndSelect'
import Select from '../parts/form/Select'
import ResetAndSubmit from '../parts/ResetAndSubmit'
import Calender from '../parts/form/Calender'
import axios from 'axios'
import * as Common from '../../common'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import ForcedLogout from '../function/ForcedLogout'

axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

/**
 * ページ名
 */
const pageType = 'project'

/**
 * ページ名（日本語）
 */
const pageTypeJa = '案件'

/**
 * 検索結果に表示する項目名リスト
 */
const resultItemName: Array<any> = [
  {
    slug: 'project_code',
    name: '案件No.',
  },
  {
    slug: 'project_name',
    name: '案件名',
  },
  {
    slug: 'property_name',
    name: '物件名',
  },
  {
    slug: 'project_manage_code',
    name: '管理番号',
  },
  {
    slug: 'supplier_code',
    name: '得意先コード',
  },
  {
    slug: 'supplier_name',
    name: '得意先名',
  },
  {
    slug: 'own_staff_name',
    name: '自社担当者',
  },
  {
    slug: 'status',
    name: 'ステータス',
  },
  {
    slug: 'status_date',
    name: 'ステータス日付',
  },
]

/**
 * トークン情報
 */
let token: String = ''

//export部分
function Project() {
  //ページタイトルを変更
  document.title = `案件一覧 | ${Common.SITE_NAME}`

  /**
   * Resultで選択しているID
   */
  const [selectedItemInResult, setSelectedItemInResult] = useState<any>(null)

  /**
   * 検索条件を編集するコンポーネントをリセットするのに使う
   * 値が変わるとリセットされる
   */
  const [valueForComponentReset, setValueForComponentReset] =
    useState<boolean>(false)

  /**
   * 検索条件を反映させるのに使う
   * 値が変わると検索条件が反映される
   */
  const [valueForSearchConditionReflect, setValueForSearchConditionReflect] =
    useState<boolean>(false)

  /**
   * 検索条件
   */
  const [resultCondition, setResultCondition] = useState<any>({
    /**
     * 昇順かどうか　true:昇順、false:降順
     */
    order: true,

    /**
     * どのプロパティで並び替えるのか
     */
    sort: 'project_code',

    /**
     * 1ページに表示する項目数　固定
     */
    limit: 10,

    /**
     * 表示するページ数
     */
    page: 1,
  })

  /**
   * 型：入力情報
   */
  interface typeInputInfo {
    /**
     * 案件ナンバー
     */
    project_code: any

    /**
     * 案件名
     */
    project_name: any

    /**
     * 物件名
     */
    m_property_id: any

    /**
     * 管理番号
     */
    project_manage_code: any

    /**
     * 得意先名
     */
    m_supplier_id: any

    /**
     * 自社担当者
     */
    m_own_company_staff_id: any

    /**
     * ステータス
     */
    project_status: any

    /**
     * ステータス日付
     */
    project_status_date: any
  }

  /**
   * 検索条件
   */
  const [inputInfo, setInputInfo] = useState<typeInputInfo>({
    project_code: '',
    project_name: '',
    m_property_id: '',
    project_manage_code: '',
    m_supplier_id: '',
    m_own_company_staff_id: '',
    project_status: '',
    project_status_date: '',
  })

  /**
   * 検索条件(InputAndSearchの表示文字)
   */
  const [inputInfoDisplay, setInputInfoDisplay] = useState<any>({
    m_property_id: '',
    m_supplier_id: '',
    m_own_company_staff_id: '',
  })

  /**
   * 検索条件(InputAndSearchのグレー部分の表示文字)
   */
  const [inputInfoOption, setInputInfoOption] = useState<any>({
    m_property_id: '',
    m_supplier_id: '',
    m_own_company_staff_id: '',
  })

  /**
   * 物件管理フラグ
   */
  const [isPropertyManagementFlag, setIsPropertyManagementFlag] =
    useState<0 | 1>(0)

  const history = useHistory()

  /**
   * 検索結果に表示する情報
   */
  const [resultObject, setResultObject] = useState<Object | null>(null)

  //tokenに、Cookieから取得したtoken情報を格納
  token = Common.getCookie('cookieToken')

  if (token !== 'not found') {
    //tokenがあったとき
    //tokenをcookieに入れ、有効期限を延長
    document.cookie =
      'cookieToken=' + token + ';max-age=' + Common.LOGIN_EXPIRE_TIME
  } else {
    //tokenがないとき
    //ログインページに遷移
    history.push('/login')
  }

  //読み込み時、1回だけ行う
  useEffect(() => {
    axios
      .get(`${Common.API_DOMAIN()}/api/api/v1/m_system_settings`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setIsPropertyManagementFlag(response.data[0].property_management_flag)
      })
      .catch((error) => {
        console.error({error})
        //エラーコードが401のとき（＝トークン有効期限切れのとき）
        if({error}.error.response.status==='401'){
          //強制ログアウト
          ForcedLogout(history, token)
        }
      })
    //物件一覧からリンクしてきてクエリパラメータが付与されている場合
    if (window.location.search) {
      //検索条件のproperty_nameから、m_property_idを導出
      //まず、APIで全物件データを取得
      axios
        .get(`${Common.API_DOMAIN()}/api/api/v1/m_properties`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {

          /**
           * property_nameの値
           */
          const searchPropertyName = Common.getParam(
            'property_name',
            window.location.href,
          )

          /**
           * 物件データ一覧から導出したm_property_id
           */
          const propertyIdForSearch = response.data.filter((value: any) => {
            return value.property_name === searchPropertyName
          })[0].id

          //上記で導出したm_property_idを、検索条件に入れる
          setInputInfo({ ...inputInfo, m_property_id: propertyIdForSearch })

          //property_nameを表示する
          setInputInfoDisplay({
            ...inputInfoDisplay,
            m_property_id: searchPropertyName,
          })

          //property_nameを表示する
          setInputInfoOption({
            ...inputInfoOption,
            m_property_id: searchPropertyName,
          })

          //検索する（useStateはすぐ反映されないので、下記useEffectを使用）
          setValueForSearchConditionReflect(!valueForSearchConditionReflect)
        })
        .catch((error) => {
          console.error({error})
          //エラーコードが401のとき（＝トークン有効期限切れのとき）
          if({error}.error.response.status==='401'){
            //強制ログアウト
            ForcedLogout(history, token)
          }
        })
    }
  }, [])

  useEffect(() => {
    onSearch()
  }, [valueForSearchConditionReflect])

  /**
   * フォームをリセット
   */
  const onReset = () => {
    /**
     * リセットするstate、およびそれを変更する関数を配列化
     */
    const resetKeys = [
      {
        value: inputInfo,
      },
      {
        value: inputInfoDisplay,
      },
      {
        value: inputInfoOption,
      },
    ]

    //各ステートに対し
    for (let resetKey of resetKeys) {
      //コピーを作成
      const temp: any = Object.assign({}, resetKey.value)

      //値を全て''にする
      for (let key in temp) {
        temp[key] = ''
      }

      //その値を各ステートに設定
      switch (resetKey.value) {
        case inputInfo:
          setInputInfo(temp)
          break
        case inputInfoDisplay:
          setInputInfoDisplay(temp)
          break
        case inputInfoOption:
          setInputInfoOption(temp)
          break
      }
    }

    //上記だと入力用コンポーネントの値はリセットされないため
    //valueForComponentResetの値を変更し、各コンポーネントをリセット
    const temp = valueForComponentReset
    setValueForComponentReset(!temp)

    //検索結果のラジオボタンの選択状態をリセット
    setSelectedItemInResult(null)

    //この次onSearchを行うが、ここに書くと値が更新されていないので
    //下記のuseEffectを使用
  }

  //inputInfoに変更があれば実行される
  useEffect(() => {
    //変わったinputInfoで、再検索
    onSearch()
  }, [valueForComponentReset])

  /**
   * 検索する
   */
  const onSearch = () => {
    /**
     * axiosで送るparams
     */
    const paramsTemp: any = Object.assign({}, inputInfo)

    //paramsTempのコピーを作る
    const params = Object.assign({}, paramsTemp)

    //キーが空の要素を消す
    Object.keys(paramsTemp).forEach((key: any) => {
      if (paramsTemp[key] === '') {
        delete params[key]
      }
    })

    //paramsの特定のキーの値にeqをつける
    const keysOfEq = [
      'm_property_id',
      'm_supplier_id',
      'm_own_company_staff_id',
      'project_status',
    ]
    keysOfEq.forEach((key: string) => {
      if (params[key]) {
        params[key] = `eq:${params[key]}`
      }
    })

    //paramsの特定のキーの値にlikeをつける
    const keysOfLike = ['project_code', 'project_name', 'project_manage_code']
    keysOfLike.forEach((key: string) => {
      if (params[key]) {
        params[key] = `like:${params[key]}`
      }
    })

    //paramsのステータスが見積もり中でない場合、
    //有効期限、予定工期、納期、請求予定日を消す
    if (params.project_status !== 1) {
      delete params.expiration_date
    }

    //paramsに検索条件を追加
    params.limit = resultCondition.limit
    params.sort = `${resultCondition.order ? '' : '-'}${resultCondition.sort}`
    params.page = resultCondition.page

    //axiosの前に、他端末がログインしていたらログアウト
    ForcedLogout(history, token)

    //APIで情報取得
    axios
      .get(`${Common.API_DOMAIN()}/api/api/v1/t_project_bases`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: params,
      })
      .then((response) => {
        setResultObject(Object.assign({}, response))
      })
      .catch((error) => {
        console.error({error})
        
        //エラーコードが401のとき（＝トークン有効期限切れのとき）
        if({error}.error.response.status==='401'){
          //強制ログアウト
          ForcedLogout(history, token)
        }
      })
  }

  /**
   * result.tsxでresultConditionが変わった場合発火する
   */
  const onChangeResultCondition = (value: any) => {
    //resultConditionを、本コンポーネントでも変更
    setResultCondition(value)

    //この次onSearchを行うが、ここに書くと値が更新されていないので
    //下記のuseEffectを使用
  }

  //resultConditionに変更があれば実行される
  useEffect(() => {
    //変わったresultConditionで、再検索
    onSearch()
  }, [resultCondition])

  /**
   * 検索ボタンを押したとき
   */
  const onSubmit = (e?: React.FormEvent) => {
    //submit処理を取り消し
    if (e) {
      e.preventDefault()
    }

    //resultConditionのページを１にリセット
    setResultCondition({ ...resultCondition, page: 1 })

    //ここで、resultConditionの変更により
    //useEffectが動き、検索が実行される
  }

  return (
    <List
      token={token}
      onChangeResultCondition={(value: any) => {
        onChangeResultCondition(value)
      }}
      resultCondition={resultCondition}
      resultObject={resultObject}
      pageType={pageType}
      pageTypeJa={pageTypeJa}
      resultItemName={resultItemName}
      selectedItemInResult={selectedItemInResult}
      onChangeselectedItemInResult={(value:any)=>{
        setSelectedItemInResult(value)
      }}
    >
      <form className="content__form" onReset={onReset} onSubmit={onSubmit}>
        <Accordion
          title="検索条件"
          isOpen="true"
          classForIdentification={pageType + '__accordion'}
          accordionType={pageType + '__search-condition'}
        >
          <ul className="form__list">
            <li className="form__item">
              <dl className="form__item-inner">
                <dt className="form__item-ttl">案件No.</dt>
                <dd className="form__item-input">
                  <div className="form__item-input-inner form__item-input-inner--input">
                    <input
                      type="text"
                      value={inputInfo.project_code}
                      onChange={(e: any) => {
                        setInputInfo({
                          ...inputInfo,
                          project_code: e.target.value,
                        })
                      }}
                    />
                  </div>
                </dd>
              </dl>
            </li>
            <li className="form__item">
              <dl className="form__item-inner">
                <dt className="form__item-ttl">案件名</dt>
                <dd className="form__item-input">
                  <div className="form__item-input-inner form__item-input-inner--input">
                    <input
                      type="text"
                      value={inputInfo.project_name}
                      onChange={(e: any) => {
                        setInputInfo({
                          ...inputInfo,
                          project_name: e.target.value,
                        })
                      }}
                    />
                  </div>
                </dd>
              </dl>
            </li>
            {isPropertyManagementFlag === 1 && (
              <li className="form__item">
                <dl className="form__item-inner">
                  <dt className="form__item-ttl">物件名</dt>
                  <dd className="form__item-input">
                    <InputAndSelect
                      key={valueForComponentReset}
                      displayValue={inputInfoDisplay.m_property_id}
                      optionValue={inputInfoOption.m_property_id}
                      onChangeValue={(value: any) => {
                        setInputInfo({ ...inputInfo, m_property_id: value })
                      }}
                      onChangeDisplayValue={(value: any) => {
                        setInputInfoDisplay({
                          ...inputInfoDisplay,
                          m_property_id: value,
                        })
                      }}
                      onChangeOptionValue={(value: any) => {
                        setInputInfoOption({
                          ...inputInfoOption,
                          m_property_id: value,
                        })
                      }}
                      name="物件名"
                      apiPath="/api/v1/m_properties"
                      apiParamKey="property_name"
                      setItemProp="property_name"
                      displayItemProp="property_name"
                      searchItemProp="id"
                      token={token}
                    ></InputAndSelect>
                  </dd>
                </dl>
              </li>
            )}

            <li className="form__item">
              <dl className="form__item-inner">
                <dt className="form__item-ttl">管理番号</dt>
                <dd className="form__item-input">
                  <div className="form__item-input-inner form__item-input-inner--input">
                    <input
                      type="text"
                      value={inputInfo.project_manage_code}
                      onChange={(e: any) => {
                        setInputInfo({
                          ...inputInfo,
                          project_manage_code: e.target.value,
                        })
                      }}
                    />
                  </div>
                </dd>
              </dl>
            </li>
            <li className="form__item">
              <dl className="form__item-inner">
                <dt className="form__item-ttl">得意先名</dt>
                <dd className="form__item-input">
                  <InputAndSelect
                    key={valueForComponentReset}
                    displayValue={inputInfoDisplay.m_supplier_id}
                    optionValue={inputInfoOption.m_supplier_id}
                    onChangeValue={(value: any) => {
                      setInputInfo({ ...inputInfo, m_supplier_id: value })
                    }}
                    onChangeDisplayValue={(value: any) => {
                      setInputInfoDisplay({
                        ...inputInfoDisplay,
                        m_supplier_id: value,
                      })
                    }}
                    onChangeOptionValue={(value: any) => {
                      setInputInfoOption({
                        ...inputInfoOption,
                        m_supplier_id: value,
                      })
                    }}
                    name="得意先名"
                    apiPath="/api/v1/m_suppliers"
                    apiParamKey="supplier_name"
                    setItemProp="supplier_name"
                    displayItemProp="supplier_name"
                    searchItemProp="id"
                    token={token}
                  ></InputAndSelect>
                </dd>
              </dl>
            </li>
            <li className="form__item">
              <dl className="form__item-inner">
                <dt className="form__item-ttl">自社担当者</dt>
                <dd className="form__item-input">
                  <InputAndSelect
                    key={valueForComponentReset}
                    displayValue={inputInfoDisplay.m_own_company_staff_id}
                    optionValue={inputInfoOption.m_own_company_staff_id}
                    onChangeValue={(value: any) => {
                      setInputInfo({
                        ...inputInfo,
                        m_own_company_staff_id: value,
                      })
                    }}
                    onChangeDisplayValue={(value: any) => {
                      setInputInfoDisplay({
                        ...inputInfoDisplay,
                        m_own_company_staff_id: value,
                      })
                    }}
                    onChangeOptionValue={(value: any) => {
                      setInputInfoOption({
                        ...inputInfoOption,
                        m_own_company_staff_id: value,
                      })
                    }}
                    name="自社担当者"
                    apiPath="/api/v1/m_own_company_staffs"
                    apiParamKey="staff_name"
                    setItemProp="staff_name"
                    displayItemProp="staff_name"
                    searchItemProp="id"
                    token={token}
                  ></InputAndSelect>
                </dd>
              </dl>
            </li>
            <li className="form__item">
              <dl className="form__item-inner">
                <dt className="form__item-ttl">ステータス</dt>
                <dd className="form__item-input">
                  <div className="form__item-input-inner form__item-input-inner--select">
                    <select
                      value={inputInfo.project_status}
                      onChange={(e: any) => {
                        setInputInfo({
                          ...inputInfo,
                          project_status: e.target.value,
                        })
                      }}
                    >
                      <option value="">　</option>
                      {Common.STATUS.project.map((data) => {
                        return (
                          <option value={data.id} key={data.id}>
                            {data.label}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                </dd>
              </dl>
            </li>
            <li className="form__item">
              <dl className="form__item-inner">
                <dt className="form__item-ttl">ステータス日付</dt>
                <dd className="form__item-input">
                  <Calender
                    key={valueForComponentReset}
                    onChangeValue={(start: Date | null, end: Date | null) => {
                      //検索に使う値を作る　開始/終了のどちらかがあれば、値を作成　なければ''
                      const value =
                        start || end ? `btn:${start || ''},${end || ''}` : ''

                      //上記で作った値を設定
                      setInputInfo({ ...inputInfo, project_status_date: value })
                    }}
                  ></Calender>
                </dd>
              </dl>
            </li>
          </ul>
        </Accordion>

        <ResetAndSubmit></ResetAndSubmit>
      </form>
    </List>
  )
}

export default Project
